import "./style.scss"
import React from "react"

const ServiceHeader = ({ title, image, text }) => {
  return (
    <div className="top_area">
      <div className="bg-area">
        <img alt="service frame" src={image} />
      </div>
      <div className="text-area">
        <h1 className="header">{title}</h1>
        <div className="mobile-service-logo">
          <img alt="service frame" src={image} />
        </div>
        <p className="text">{text}</p>
      </div>
    </div>
  )
}

export default ServiceHeader
